import * as React from 'react';
import Grid from '@mui/material/Grid';

import AddressLookup from './AddressLookup';
import { Typography } from '@mui/material';


class UserOverview extends React.Component<any, any> {

    render() {
        return <Grid container spacing={2}>
        <Grid item xs={12} >
          <Typography variant="h5"  sx={{overflow: 'hidden',textOverflow: 'ellipsis' }}>
            Overview for {this.props.user_ens || this.props.user_address}
          </Typography>
          <AddressLookup user_address={this.props.user_address} setUserAddress={this.props.setUserAddress} />
        </Grid>
        <Grid item xs={12}>
          Number of Digital Certificates owned: {this.props.nftrees.length} <br/>
          Has member card: {this.props.has_member_card} <br/>
          Number of Bloomeria's Digital Certificates collections owned: {this.props.items.length}
        </Grid>
      </Grid> 
        
    }
}

export default UserOverview